module.exports = __webpack_public_path__ + "media/images/logo/p-mark-ed9fc092c8a3a7665e8e64b3a0f98850.png";